import React from "react";
import { Row, Col } from "antd";

import { SignInForm } from "../Forms/Auth";
import AuthContainer from "../../modules/auth/containers/Auth";
import withUnAuth from "./withUnAuth";

const SignInPage = ({ doSignIn }) => {
  return (
    <div className="SignInPage">
      <Row>
        <Col xs={24} sm={24} md={{ offset: 6, span: 12 }}>
          <SignInForm doSignIn={doSignIn} />
        </Col>
      </Row>
    </div>
  );
};

export default withUnAuth(AuthContainer(SignInPage));
